import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { ReviewRating, Link } from "@quintype/components";
import { HeroImageCaption } from "../elements/image-caption";
import styles from "./styles.m.css";

import { getStoryData } from "../../../../../utils/utils";
import { isPremium } from "../../../../../../data/story";
import StoryPremiumCard from "../../../../../atoms/story-premium-card";
// import { CategoryBadgeTextStory } from "../../../../../atoms/category-badge-text-story";
// import { CategoryBadge } from "../../../../../atoms/category-badge";
import { MyVikatanBadgeArticle } from "../../../../../atoms/my-vikatan-badge-article";
import AssettypeImage from "../../../../../atoms/responsive-image-with-fallback/assetypeImage";

const ReviewHeroImageWithRating = ({ story, className = "" }) => {
  const imageData = getStoryData(story, false);
  let ratingValue = get(story, ["metadata", "review-rating", "value"], 0);
  const ratingTitle = get(story, ["metadata", "review-title"], "திரைப்பட மதிப்பீடு");
  return (
    <div className={`${styles["hero-image-8x5"]} ${className}`}>
      <figure className={`${styles["image-wrapper"]} qt-figure`}>
        <AssettypeImage
          eager
          slug={imageData.imageS3Key}
          metadata={imageData.imageMetadata}
          alt={imageData.imageCaption}
          aspectRatio={[8, 5]}
          defaultWidth={480}
          widths={[400, 700, 900]}
          sizes="(max-width: 1024px) 100vw, 70vw"
          imgParams={{ auto: ["format", "compress"] }}
        />
      </figure>

      <div className={styles.review}>
        <h4 className={styles["review-label"]}>{ratingTitle}</h4>
        <ReviewRating value={ratingValue} canShowEmptyRating={true} />
      </div>
    </div>
  );
};

ReviewHeroImageWithRating.propTypes = {
  className: PropTypes.string,
  reviewLabel: PropTypes.string,
  ratingTitle: PropTypes.string,
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

const LongFormHeroImage = ({ story, className = "" }) => {
  const storyData = getStoryData(story, false);

  return (
    <div className={`${styles["hero-image-24x7"]} ${className}`}>
      <figure className={`${styles["image-wrapper"]} qt-figure`}>
        <AssettypeImage
          eager
          slug={storyData.imageS3Key}
          metadata={storyData.imageMetadata}
          alt={storyData.imageCaption}
          aspectRatio={[24, 7]}
          defaultWidth={480}
          widths={[400, 700, 900]}
          sizes="(max-width: 1024px) 100vw, 70vw"
          imgParams={{ auto: ["format", "compress"] }}
        />
      </figure>
    </div>
  );
};

LongFormHeroImage.propTypes = {
  className: PropTypes.string,
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

const HeroImageTextStory = ({ story, subSection, config, className = "", icon = "magazines", showApp = false }) => {
  const storyData = getStoryData(story, false);
  const cluster = get(story, ["metadata", "story-attributes", "cluster", "0"], "");

  if (storyData.hasOwnProperty("imageS3Key") && storyData.imageS3Key) {
    return (
      <div className={`${styles["hero-image"]}`}>
        <div className={`${styles["hero-wrapper"]}`}>
          <figure className={`${styles["image-wrapper"]} qt-figure`}>
            <AssettypeImage
              eager
              slug={storyData.imageS3Key}
              metadata={storyData.imageMetadata}
              alt={storyData.imageCaption}
              aspectRatio={[16, 9]}
              defaultWidth={700}
              widths={[400, 700, 900]}
              sizes="(max-width: 500px) 400px, (max-width: 768px) 700px, 900px"
              imgParams={{ auto: ["format", "compress"] }}
            />
            <MyVikatanBadgeArticle isMyVikatan={cluster === "MyVikatan"} />
          </figure>
          {isPremium(story) && <StoryPremiumCard className={`${styles["premium"]}`} />}
          {/* <CategoryBadgeTextStory icon={icon} subSection={subSection} config={config} color={"#e92227"} /> */}
        </div>
        <HeroImageCaption storyData={storyData} />
      </div>
    );
  } else {
    return null;
  }
};

HeroImageTextStory.propTypes = {
  className: PropTypes.string,
  config: PropTypes.shape({
    section: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string
      })
    ),
    "publisher-name": PropTypes.string
  }),
  subSection: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string
  }),
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

const HeroImageDeals = ({ story }) => {
  const storyData = getStoryData(story, false);
  if (storyData.hasOwnProperty("imageS3Key") && storyData.imageS3Key) {
    return (
      <div className={`${styles["hero-image"]} ${styles["deals-image"]}`}>
        <div className={`${styles["hero-wrapper"]}`}>
          <figure className={`${styles["image-wrapper"]} qt-figure`}>
            <AssettypeImage
              eager
              slug={storyData.imageS3Key}
              metadata={storyData.imageMetadata}
              alt={storyData.imageCaption}
              aspectRatio={[16, 9]}
              defaultWidth={700}
              widths={[400, 700, 900]}
              sizes="(max-width: 500px) 400px, (max-width: 768px) 700px, 900px"
              imgParams={{ auto: ["format", "compress"] }}
            />
          </figure>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

HeroImageDeals.propTypes = {
  className: PropTypes.string,
  subSection: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string
  }),
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

const HeroImage = ({ story, className = "", icon = "magazines", headline = "News", showApp = false }) => {
  const storyData = getStoryData(story, false);
  const cluster = get(story, ["metadata", "story-attributes", "cluster", "0"], "");

  const openAppUrl = `https://onelink.to/webleaderboard`;
  if (storyData.hasOwnProperty("imageS3Key") && storyData.imageS3Key) {
    return (
      <div className={`${styles["hero-image"]}`}>
        {showApp && (
          <Link aria-label={`Read In  APP`} href={openAppUrl} className={`hidden-desktop`}>
            <div className={`${styles["add-shortcut"]} hidden-desktop`}>
              <img
                src="https://media.vikatan.com/vikatan/2021-12/3baa6390-46ba-4934-8052-7ac4c3e9d59a/use_app.png"
                width="300px"
                height="55px"
              />
            </div>
          </Link>
        )}
        <div className={`${styles["hero-wrapper"]}`}>
          <figure className={`${styles["image-wrapper"]} qt-figure`}>
            <AssettypeImage
              eager
              slug={storyData.imageS3Key}
              metadata={storyData.imageMetadata}
              alt={storyData.imageCaption}
              aspectRatio={[16, 9]}
              defaultWidth={700}
              widths={[400, 700, 900]}
              sizes="(max-width: 768px) 400px, (max-width: 1024px) 700px, 900px"
              imgParams={{ auto: ["format", "compress"] }}
            />
            <MyVikatanBadgeArticle isMyVikatan={cluster === "MyVikatan"} />
          </figure>
          {isPremium(story) && <StoryPremiumCard className={`${styles["premium"]}`} />}
          {/* <CategoryBadge icon={icon} headline={headline} color={"#e92227"} /> */}
        </div>
        <HeroImageCaption storyData={storyData} />
      </div>
    );
  } else {
    return null;
  }
};

HeroImage.propTypes = {
  className: PropTypes.string,
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

export { HeroImageTextStory, HeroImage, LongFormHeroImage, ReviewHeroImageWithRating, HeroImageDeals };
